import { ServiceDataEvent } from 'domains/store/store.types'
import { FC } from 'preact/compat'
import { className } from '../../../lib/css'
import SuggestionsItem from './suggestions-item'

type SuggestionsListProps = {
  className?: string
  onClickSuggestion: (_args: {
    id: string | number | undefined
    question?: string | undefined
  }) => void
  suggestions?: ServiceDataEvent['payload']['body']
  hasIcon?: boolean
}

const SuggestionsList: FC<SuggestionsListProps> = ({
  className: givenClassName,
  suggestions = [],
  onClickSuggestion,
  hasIcon = true,
}) => (
  <ul className={className('suggestions__list', givenClassName || '')}>
    {suggestions.map((suggestion) => (
      <SuggestionsItem
        hasIcon={hasIcon}
        key={suggestion.id}
        onClick={onClickSuggestion}
        categories={suggestion.categories}
        id={suggestion.id}
        question={suggestion.question}
      />
    ))}
  </ul>
)

export default SuggestionsList
